import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@axios';

// Modules
import StatsModule from '@/store/modules/StatsModule';
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import AuthModule from './modules/AuthModule';
import { REST_ENDPOINT, REST_ENDPOINT_AU } from '../../endpoints';

const regionKey = 'userRegion';
const endpointKey = 'restEndpoint';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    region: 'UK',
  },
  mutations: {
    SET_REGION(state, value) {
      state.region = value;
      localStorage.setItem(regionKey, value);

      if (value === 'UK') {
        localStorage.setItem(endpointKey, REST_ENDPOINT);
      } else if (value === 'Australia') {
        localStorage.setItem(endpointKey, REST_ENDPOINT_AU);
      } else { // default
        localStorage.setItem(endpointKey, REST_ENDPOINT);
      }

      axios.defaults.baseURL = localStorage.getItem(endpointKey);
    },
  },
  actions: {
    setRegionFromLocal({ commit, state }) {
      const region = localStorage.getItem(regionKey);

      commit('SET_REGION', region || state.region);
    },
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth: AuthModule,
    stats: StatsModule,
  },
  strict: process.env.DEV,
})
